import getPropFromModule from './getPropFromModule';
import { OUT_OF_DELIVERY_ERROR } from '../model';

const getIsOutOfDeliveryError = state =>
  getPropFromModule(state, OUT_OF_DELIVERY_ERROR);

export default getIsOutOfDeliveryError;
